import { useState } from 'react';

import { ModalityEnum } from 'domain/usecases/private/refund/request-preview';
import { useRequestPreviewFlowStore } from '../../../store/useRequestPreviewFlowStore';
import { useStepPreviewStore } from '../../../store/useStepPreviewStore';
import { StepPreviewEnum, StepPreviewEnumV2 } from '../../../types';
import { SelectTypeOptionLabels, SelectTypeOptionValue } from '../types';

const OPTIONS: SelectTypeOptionValue[] = Object.values(SelectTypeOptionLabels);


export const useSelectType = () => {
	const setStep = useStepPreviewStore(state => state.setStep);
	const setUseServiceTypeFormV2 = useRequestPreviewFlowStore(
		state => state.setUseServiceTypeFormV2,
	);
	const setPreselectedModality = useRequestPreviewFlowStore(
		state => state.setPreselectedModality,
	);
	const setSelectedServiceTypeOption = useRequestPreviewFlowStore(
		state => state.setSelectedServiceTypeOption,
	);
	const [infoModalVisible, setInfoModalVisible] = useState(false);

	const handleOptionClick = (option: SelectTypeOptionValue) => {
		if (
			option === SelectTypeOptionLabels.CONSULTA ||
			option === SelectTypeOptionLabels.EXAMES ||
			option === SelectTypeOptionLabels.TERAPIAS
		) {
			setStep(StepPreviewEnumV2.PROCEDURES);
			setSelectedServiceTypeOption(option);
		} else if (option === SelectTypeOptionLabels.INTERNACAO) {
			setUseServiceTypeFormV2(false);
			setPreselectedModality(ModalityEnum.HOSPITALIZATIONS);
			setStep(StepPreviewEnum.SERVICE_TYPE);
		}
	};

	return { handleOptionClick, options: OPTIONS, infoModalVisible, setInfoModalVisible };
};
